import axios from "axios";
import {
    MessageBox
} from "element-ui";
import store from "../store";
import {
    getToken,
    getNameAndValue
} from "./localStorage";

// create axios instance
const service = axios.create({
    //baseURL: process.env.BASE_API, // api base_url
    timeout: 300000
});

function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";

    let uuid = s.join("");
    return uuid;
}
// request interceptors
service.interceptors.request.use(
    config => {
        config.headers["X-API-RequestId"] = uuid();
        let jwt = getToken();
        let id = getNameAndValue("id");
        if (jwt) {
            config.headers["X-API-Token"] = jwt; // add token to header
        }
        if (id) {
            config.headers["X-API-Id"] = id;
        }
        let randomData = Math.random();
        if (config.url.indexOf("?") > -1) {
            config.url = config.url + "&random=" + randomData;
        } else {
            config.url = config.url + "?random=" + randomData;
        }
        return config;
    },
    error => {
        // Do something with request error
        console.log(error); // for debug
        Promise.reject(error);
    }
);

// response interceptors
service.interceptors.response.use(
    response => {
        /* const res = response.data
         if (res.status > 300 && res.code < 200) {
          Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000
          })

          return Promise.reject('error')
        } else {
          return response.data
        }*/
        return response;
    },
    error => {
        console.log(error); // for debug
        const res = (error.status) || undefined;
        // Message({
        //     message: res ? res.hint : error.responseStatus,
        //     type: "error",
        //     duration: 5 * 1000
        // });
        if (res && res.responseStatus === "401401") {
            MessageBox.confirm(res.status.Hint, "Logout", {
                confirmButtonText: "Login Again",
                cancelButtonText: "Cancel",
                type: "warning"
            }).then(() => {
                store.dispatch("FedLogOut").then(() => {
                    location.reload();
                });
            });
        }
        return Promise.reject(error);
    }
);

export default service;
